import { ConsumerLoanInitPayload } from '../domain/types/ConsumerLoanInitPayload';
import { apiClient } from './apiClient';

export const encryptInitPayloadService = async (
    apiProxyPath: string,
    apiKey: string,
    initPayload: ConsumerLoanInitPayload,
): Promise<string> => {
    return apiClient<string>(`${apiProxyPath}/encrypt`, {
        method: 'POST',
        body: initPayload,
        apiKey,
        responseType: 'text',
        sentryTag: 'encrypt_init_payload',
    });
};

export const decryptInitPayloadService = async (
    apiProxyPath: string,
    apiKey: string,
    encryptedApplicationState: string,
): Promise<ConsumerLoanInitPayload> => {
    return apiClient<ConsumerLoanInitPayload>(`${apiProxyPath}/decrypt`, {
        method: 'POST',
        body: encryptedApplicationState,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        apiKey,
        sentryTag: 'decrypt_init_payload',
    });
};
